import { getAssetPlatformLink, getNaviMineLink } from '@/lib/platform';
import { useEffect } from 'react';
import useUserStore from 'store/user';
import ImgAsset1 from 'assets/images/link_BALANCER_NaviMine.png';

import { useNavigate } from 'react-router-dom';

export default function Spotlight() {
  // store
  const { ids } = useUserStore();

  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      if (!ids.pointId) {
        navigate('/');
        return;
      }
    })();

    return () => {};
  }, []);

  // method

  const handlePlatformLinkClick = (value: string) => {
    let link = '';
    switch (value) {
      case 'navimine':
        link = getNaviMineLink();
        break;

      default:
        link = getAssetPlatformLink();
        break;
    }
    // const link = value === 'asset' ? getAssetPlatformLink() : getPlatformLink();
    window.open(link, '_blank');
  };

  return (
    <div className="flex h-full flex-col">
      <div className="px-[16px] py-[20px]">
        <div className="mb-[10px] flex items-center gap-[5px]">
          <div className="mb-[3px] h-[8px] w-[8px] rounded-full bg-[#FF4F19]" />
          <h3 className="text-[15px] font-[800] text-[#FF4F19]">Spotlight</h3>
        </div>

        <div className="w-full flex-1">
          <img
            src={ImgAsset1} // 원하는 이미지 경로
            alt="에셋파이"
            className="h-auto w-full cursor-pointer rounded-lg"
            onClick={() => handlePlatformLinkClick('navimine')}
          />
        </div>
        <div className="mb-[20px]" />
        {/* <div className="w-full flex-1">
          <img
            src={ImgAsset2} // 원하는 이미지 경로
            alt="셔플 설치"
            className="h-auto w-full cursor-pointer rounded-lg"
            onClick={() => handlePlatformLinkClick('shuffle')}
          />
        </div> */}
      </div>
    </div>
  );
}
